import { Container } from 'ui/container'
import { BattlesAdmin } from 'features/admin/battles'
import { Link } from 'react-router-dom'
import { routes } from 'core/routes/paths'

import c from '../assets/sass/page.module.scss'

const AdminBattlesPage = () => {
    return (
        <div className={c.component}>
            <div className={c.header}>
                <Link to={routes.admin} className={c.back}>
                    ← Назад
                </Link>
                <span className={c.title}>Батлы</span>
            </div>
            <Container>
                <BattlesAdmin />
            </Container>
        </div>
    )
}

export default AdminBattlesPage
